var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxSelectedPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#99B2F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 5.3125C17.0938 5.6875 17.0938 6.34375 16.6875 6.71875L8.6875 14.7188C8.3125 15.125 7.65625 15.125 7.28125 14.7188L3.28125 10.7188C2.875 10.3438 2.875 9.6875 3.28125 9.3125C3.65625 8.90625 4.3125 8.90625 4.6875 9.3125L8 12.5938L15.2812 5.3125C15.6562 4.90625 16.3125 4.90625 16.6875 5.3125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelectedPurple);
export default __webpack_public_path__ + "static/media/CheckboxSelected_purple.cbed326fa02a016cab3e15d6eba81e9f.svg";
export { ForwardRef as ReactComponent };